import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { paymentUrls } from 'src/app/utils/apiUrls';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) { }

  createOrder(webinarId: string,payload: any): Observable<any> {
    return this.http.post(`${paymentUrls.createOrder}/create-order`, payload, {
      params: { webinarPostId: webinarId }
    });
  }
  verifyPayment(paymentData: any): Observable<any> {
    console.log("jsdhajkhasjdhf----->", paymentData);
    return this.http.post(`${paymentUrls.verifyPayment}/verify`, paymentData);
  }
  getPaymentStatus(orderId: string): Observable<any> {
    return this.http.get(`${paymentUrls.paymentstatus}/status`, {
      params: { orderId: orderId }
    });
  }
}
